// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"load_wrapper__2TZo7","image":"load_image__1HkMu"};